
const readCookie = (name: string): string | undefined => {
  try {
    if (typeof document === 'undefined') return undefined
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`))
    const value = match ? decodeURIComponent(match[1]) : ''
    return value || undefined
  } catch {
    return undefined
  }
}

// Meta browser/click IDs, forwarded to the API for Conversions API matching.
// Keys are left out when the cookie is missing, never sent as null or ''.
export const getMetaCookies = (): { fbp?: string; fbc?: string } => {
  const cookies: { fbp?: string; fbc?: string } = {}
  const fbp = readCookie('_fbp')
  const fbc = readCookie('_fbc')
  if (fbp) cookies.fbp = fbp
  if (fbc) cookies.fbc = fbc
  return cookies
}
